import { SchoolData } from "@nimble/candidate-api/types";
import { PrincipalSubscriptionStatus } from "@nimble/data-service-client/types";

export const getIsOnConnect = (schoolData: SchoolData) => {
  return (
    schoolData.principal_subscription_status ===
    PrincipalSubscriptionStatus.ON_PLATFORM
  );
};
